import { me } from "@/api/auth.api";
import { GetAuthMeResponse, PostAuthSignInResponse } from "@/types/api/api-types";
import { atom, createStore } from "jotai";
import { atomWithStorage } from "jotai/utils";

export type User = {
  role: string;
  isBoUser: boolean;
  companyId: string;
  userId: string;
};

export const authStore = createStore();

const hydrateUser = () => {
  try {
    const storedValue = localStorage.getItem("User");
    if (!storedValue) return null;
    return JSON.parse(localStorage.getItem("User")!);
  } catch (error) {
    return null;
  }
};

const hydrateAccessToken = () => {
  try {
    const storedValue = localStorage.getItem("AccessToken");
    if (!storedValue) return null;
    return JSON.parse(localStorage.getItem("AccessToken")!);
  } catch (error) {
    return null;
  }
};

const hydrateRefreshToken = () => {
  try {
    const storedValue = localStorage.getItem("RefreshToken");
    if (!storedValue) return null;
    return JSON.parse(localStorage.getItem("RefreshToken")!);
  } catch (error) {
    return null;
  }
};

export const userAtom = atomWithStorage<User | null>("User", hydrateUser());
export const accessTokenAtom = atomWithStorage<string | null>("AccessToken", hydrateAccessToken());
export const refreshTokenAtom = atomWithStorage<string | null>(
  "RefreshToken",
  hydrateRefreshToken(),
);
export const isAuthenticatedAtom = atom((get) => !!get(userAtom));

export const refreshUser = async () => {
  const response = await me();
  if (response) {
    updateUser(response);
  }
};

export const updateUser = async (data: GetAuthMeResponse) => {
  authStore.set(userAtom, {
    role: data.role,
    isBoUser: data.isBoUser,
    companyId: data.companyId,
    userId: data.userId,
  });
};

export const login = async (data: PostAuthSignInResponse) => {
  authStore.set(userAtom, {
    role: data.role,
    isBoUser: data.isBoUser,
    companyId: data.companyId,
    userId: data.userId,
  });
  authStore.set(accessTokenAtom, data.accessToken);
  authStore.set(refreshTokenAtom, data.refreshToken);
};

export const logout = () => {
  authStore.set(userAtom, null);
  authStore.set(accessTokenAtom, null);
  authStore.set(refreshTokenAtom, null);

  window.dispatchEvent(new CustomEvent("logout"));
};
